import React, { useState } from 'react';
import { SlideDown } from 'react-slidedown';

import { Container, NameArea, Name, Collapse, Expand, Content } from './styles';

interface Props {
  name: string;
  children: JSX.Element | JSX.Element[];
  count?: number;
  changed?: boolean;
  isOpen?: boolean;
  className?: string;
}

const FilterItem = ({ name, children, count, changed, isOpen = false, className = '' }: Props) => {
  const [isExpanded, setIsExpanded] = useState(isOpen);

  const toggleIsExpanded = () => setIsExpanded(!isExpanded);

  return (
    <Container className={className}>
      <NameArea onClick={toggleIsExpanded}>
        <Name $active={changed || count ? true : false}>
          {name}
          {changed ? '*' : ''} {count ? `(${count})` : ''}
        </Name>
        {isExpanded ? <Collapse /> : <Expand />}
      </NameArea>
      <SlideDown>{isExpanded && <Content>{children}</Content>}</SlideDown>
    </Container>
  );
};

export default FilterItem;
